var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordHidden(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.85352 13.5L14.3535 1.5L1.85352 13.5Z",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.85352 13.5L14.3535 1.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6 12.1999C6.64732 12.402 7.32189 12.5032 8 12.4999C10.7333 12.5466 13.5067 10.6266 15.2133 8.73992C15.3974 8.53744 15.4995 8.27359 15.4995 7.99992C15.4995 7.72625 15.3974 7.46241 15.2133 7.25992C14.5962 6.57783 13.9104 5.96124 13.1667 5.41992",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.3928 4.34654C10.3437 3.80227 9.18129 3.51224 7.99945 3.49987C5.33279 3.45321 2.53279 5.33321 0.78612 7.25987C0.602015 7.46236 0.5 7.7262 0.5 7.99987C0.5 8.27355 0.602015 8.53739 0.78612 8.73987C1.73271 9.79808 2.84224 10.6983 4.07279 11.4065",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.99821 9.547C5.63656 9.04527 5.46824 8.42983 5.52421 7.81388C5.58018 7.19794 5.85668 6.62292 6.30284 6.1946C6.74901 5.76628 7.33483 5.51347 7.95255 5.48268C8.57026 5.45188 9.17833 5.64517 9.66488 6.027",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.5 8C10.5 8.3283 10.4353 8.65339 10.3097 8.95671C10.1841 9.26002 9.99991 9.53562 9.76777 9.76777C9.53562 9.99991 9.26002 10.1841 8.95671 10.3097C8.65339 10.4353 8.3283 10.5 8 10.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHidden);
export default __webpack_public_path__ + "static/media/password-hidden.bd747cac908f9feaf74904f92e2849c2.svg";
export { ForwardRef as ReactComponent };